import { Link } from "react-router-dom";
function LandingPage() {
    return(

    <div className="container-fluid">
        <h4>Link to HW3 Landing Page</h4>
        <nav>
            <Link to="/HW3LandingPage">Cobs Game Site</Link>
        </nav>
        <h3>Link to HW4 Landing Page: </h3>
        <nav>
            
            <Link to="SoulMusic">HW4 Music Site</Link>
        </nav>
     </div>
    );
}

export default LandingPage;